import { configureStore } from "@reduxjs/toolkit";

import accountSlice from "../features/account/accountSlice";
import announcementSlice from "../features/announcement/announcementSlice";
import AssetsSlice from "../features/assets/assetsSlice";
import attendanceReducer from "../features/attendance/attendanceSlice";
import awardSlice from "../features/award/awardSlice";
import awardHistorySlice from "../features/awardHistory/awardHistorySlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import dayPartSlice from "../features/dayPartSchedule/dayPartSlice";
import designationReducer from "../features/designation/designationSlice";
import documentSlice from "../features/document/documentSlice";
import employmentStatusSlice from "../features/employemntStatus/employmentStatusSlice";
import expenseSlice from "../features/expense/expenseSlice";
import expenseProjectSlice from "../features/expenseProject/expenseProjectSlice";
import leaveSlice from "../features/leave/leaveSlice";
import leavePolicySlice from "../features/leavePolicy/leavePolicySlice";
import linkUserSlice from "../features/linkUser/linkUserSlice";
import terminationReasonSlice from "../features/masters/terminationReasonSlice";
import paymentSlice from "../features/payment/paymentSlice";
import payrollSlice from "../features/payroll/payrollSlice";
import AssignedTaskSlice from "../features/projectManagement/project/assignedTask/assignedTask";
import milestoneSlice from "../features/projectManagement/project/milestone/milestone";
import projectSlice from "../features/projectManagement/project/project/project";
import projectTaskSlice from "../features/projectManagement/project/projectTask/projectTask";
import projectTeamSlice from "../features/projectManagement/project/projectTeam/projectTeam";
import taskDependencySlice from "../features/projectManagement/project/taskDependency/taskDependency";
import taskPrioritySlice from "../features/projectManagement/project/taskPriority/taskPriority";
import taskStatusSlice from "../features/projectManagement/project/taskStatus/taskStatus";
import taskTimeSlice from "../features/projectManagement/project/taskTime/taskTime";
import publicHolidaySlice from "../features/publicHoliday/publicHolidaySlice";
import salaryComponentsSlice from "../features/salaryComponent/salaryComponentSlice";
import setUpSlice from "../features/setUp/setUpSlice";
import shiftSlice from "../features/shift/shiftSlice";
import terminationSlice from "../features/termination/terminationSlice";
import transactionSlice from "../features/transaction/transactionSlice";
import userReducer from "../features/user/userSlice";
import weeklyHolidaySlice from "../features/weeklyHoliday/weeklyHolidaySlice";
import taskHistorySlice from "../features/taskStatusHistory/taskStatusHistorySlice";
import salaryHistorySlice from "../features/salary/salarySlice";

const reduxLogger = require("redux-logger");
const logger = reduxLogger.createLogger();

const store = configureStore({
	reducer: {
		users: userReducer,
		dashboard: dashboardReducer,
		designations: designationReducer,
		payroll: payrollSlice,
		payment: paymentSlice,
		shift: shiftSlice,
		employmentStatus: employmentStatusSlice,
		attendance: attendanceReducer,
		leave: leaveSlice,
		expense: expenseSlice,
		accounts: accountSlice,
		transactions: transactionSlice,
		announcement: announcementSlice,
		award: awardSlice,
		awardHistory: awardHistorySlice,
		leavePolicy: leavePolicySlice,
		weeklyHoliday: weeklyHolidaySlice,
		publicHoliday: publicHolidaySlice,
		milestone: milestoneSlice,
		project: projectSlice,
		projectTask: projectTaskSlice,
		projectTeam: projectTeamSlice,
		taskDependency: taskDependencySlice,
		taskStatus: taskStatusSlice,
		taskTime: taskTimeSlice,
		taskPriority: taskPrioritySlice,
		salaryComponents: salaryComponentsSlice,
		linkUser: linkUserSlice,
		document: documentSlice,
		AssignedTask: AssignedTaskSlice,
		asset: AssetsSlice,
		setUp: setUpSlice,
		dayPart :dayPartSlice,
		terminationReason: terminationReasonSlice,
		termination: terminationSlice,
		expenseProject: expenseProjectSlice,
		taskHistory: taskHistorySlice,
		salaryHistory: salaryHistorySlice

	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
	// middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

export default store;
